/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { doctorEncuestasControllerClonarEncuesta } from '../fn/doctor-encuestas/doctor-encuestas-controller-clonar-encuesta';
import { DoctorEncuestasControllerClonarEncuesta$Params } from '../fn/doctor-encuestas/doctor-encuestas-controller-clonar-encuesta';
import { doctorEncuestasControllerCrearEncuesta } from '../fn/doctor-encuestas/doctor-encuestas-controller-crear-encuesta';
import { DoctorEncuestasControllerCrearEncuesta$Params } from '../fn/doctor-encuestas/doctor-encuestas-controller-crear-encuesta';
import { doctorEncuestasControllerEditarEncuesta } from '../fn/doctor-encuestas/doctor-encuestas-controller-editar-encuesta';
import { DoctorEncuestasControllerEditarEncuesta$Params } from '../fn/doctor-encuestas/doctor-encuestas-controller-editar-encuesta';
import { doctorEncuestasControllerEliminarEncuesta } from '../fn/doctor-encuestas/doctor-encuestas-controller-eliminar-encuesta';
import { DoctorEncuestasControllerEliminarEncuesta$Params } from '../fn/doctor-encuestas/doctor-encuestas-controller-eliminar-encuesta';
import { doctorEncuestasControllerObtenerDetallesEncuesta } from '../fn/doctor-encuestas/doctor-encuestas-controller-obtener-detalles-encuesta';
import { DoctorEncuestasControllerObtenerDetallesEncuesta$Params } from '../fn/doctor-encuestas/doctor-encuestas-controller-obtener-detalles-encuesta';
import { doctorEncuestasControllerObtenerEncuestas } from '../fn/doctor-encuestas/doctor-encuestas-controller-obtener-encuestas';
import { DoctorEncuestasControllerObtenerEncuestas$Params } from '../fn/doctor-encuestas/doctor-encuestas-controller-obtener-encuestas';
import { doctorEncuestasControllerObtenerEncuestasDeUsuarios } from '../fn/doctor-encuestas/doctor-encuestas-controller-obtener-encuestas-de-usuarios';
import { DoctorEncuestasControllerObtenerEncuestasDeUsuarios$Params } from '../fn/doctor-encuestas/doctor-encuestas-controller-obtener-encuestas-de-usuarios';
import { doctorEncuestasControllerObtenerRespuestasEncuesta } from '../fn/doctor-encuestas/doctor-encuestas-controller-obtener-respuestas-encuesta';
import { DoctorEncuestasControllerObtenerRespuestasEncuesta$Params } from '../fn/doctor-encuestas/doctor-encuestas-controller-obtener-respuestas-encuesta';
import { doctorEncuestasControllerObtenerRespuestasPaciente } from '../fn/doctor-encuestas/doctor-encuestas-controller-obtener-respuestas-paciente';
import { DoctorEncuestasControllerObtenerRespuestasPaciente$Params } from '../fn/doctor-encuestas/doctor-encuestas-controller-obtener-respuestas-paciente';
import { doctorEncuestasControllerObtenerUsuariosEncuesta } from '../fn/doctor-encuestas/doctor-encuestas-controller-obtener-usuarios-encuesta';
import { DoctorEncuestasControllerObtenerUsuariosEncuesta$Params } from '../fn/doctor-encuestas/doctor-encuestas-controller-obtener-usuarios-encuesta';
import { EncuestaDto } from '../models/encuesta-dto';
import { EncuestaPacienteModelDto } from '../models/encuesta-paciente-model-dto';
import { ListadoEncuestasModelDto } from '../models/listado-encuestas-model-dto';
import { PacienteEncuestaRespuestaModelDto } from '../models/paciente-encuesta-respuesta-model-dto';
import { PacienteModelDto } from '../models/paciente-model-dto';
import { RespuestaEncuestaPacienteModelDto } from '../models/respuesta-encuesta-paciente-model-dto';

@Injectable({ providedIn: 'root' })
export class DoctorEncuestasService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `doctorEncuestasControllerObtenerEncuestas()` */
  static readonly DoctorEncuestasControllerObtenerEncuestasPath = '/api/doctor-encuestas/lista-encuestas';

  /**
   * Obtener todas las encuestas.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `doctorEncuestasControllerObtenerEncuestas()` instead.
   *
   * This method doesn't expect any request body.
   */
  doctorEncuestasControllerObtenerEncuestas$Response(params?: DoctorEncuestasControllerObtenerEncuestas$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ListadoEncuestasModelDto>>> {
    return doctorEncuestasControllerObtenerEncuestas(this.http, this.rootUrl, params, context);
  }

  /**
   * Obtener todas las encuestas.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `doctorEncuestasControllerObtenerEncuestas$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  doctorEncuestasControllerObtenerEncuestas(params?: DoctorEncuestasControllerObtenerEncuestas$Params, context?: HttpContext): Observable<Array<ListadoEncuestasModelDto>> {
    return this.doctorEncuestasControllerObtenerEncuestas$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ListadoEncuestasModelDto>>): Array<ListadoEncuestasModelDto> => r.body)
    );
  }

  /** Path part for operation `doctorEncuestasControllerCrearEncuesta()` */
  static readonly DoctorEncuestasControllerCrearEncuestaPath = '/api/doctor-encuestas/crear-encuesta';

  /**
   * Crear una nueva encuesta.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `doctorEncuestasControllerCrearEncuesta()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  doctorEncuestasControllerCrearEncuesta$Response(params: DoctorEncuestasControllerCrearEncuesta$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return doctorEncuestasControllerCrearEncuesta(this.http, this.rootUrl, params, context);
  }

  /**
   * Crear una nueva encuesta.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `doctorEncuestasControllerCrearEncuesta$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  doctorEncuestasControllerCrearEncuesta(params: DoctorEncuestasControllerCrearEncuesta$Params, context?: HttpContext): Observable<void> {
    return this.doctorEncuestasControllerCrearEncuesta$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `doctorEncuestasControllerEditarEncuesta()` */
  static readonly DoctorEncuestasControllerEditarEncuestaPath = '/api/doctor-encuestas/editar-encuesta/{uuidEncuesta}';

  /**
   * Editar una encuesta existente.
   *
   * Edita una encuesta y sus preguntas/respuestas asociadas.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `doctorEncuestasControllerEditarEncuesta()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  doctorEncuestasControllerEditarEncuesta$Response(params: DoctorEncuestasControllerEditarEncuesta$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return doctorEncuestasControllerEditarEncuesta(this.http, this.rootUrl, params, context);
  }

  /**
   * Editar una encuesta existente.
   *
   * Edita una encuesta y sus preguntas/respuestas asociadas.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `doctorEncuestasControllerEditarEncuesta$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  doctorEncuestasControllerEditarEncuesta(params: DoctorEncuestasControllerEditarEncuesta$Params, context?: HttpContext): Observable<void> {
    return this.doctorEncuestasControllerEditarEncuesta$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `doctorEncuestasControllerEliminarEncuesta()` */
  static readonly DoctorEncuestasControllerEliminarEncuestaPath = '/api/doctor-encuestas/eliminar-encuesta/{uuidEncuesta}';

  /**
   * Eliminar una encuesta.
   *
   * Elimina una encuesta y todas sus preguntas y respuestas asociadas (soft delete).
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `doctorEncuestasControllerEliminarEncuesta()` instead.
   *
   * This method doesn't expect any request body.
   */
  doctorEncuestasControllerEliminarEncuesta$Response(params: DoctorEncuestasControllerEliminarEncuesta$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return doctorEncuestasControllerEliminarEncuesta(this.http, this.rootUrl, params, context);
  }

  /**
   * Eliminar una encuesta.
   *
   * Elimina una encuesta y todas sus preguntas y respuestas asociadas (soft delete).
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `doctorEncuestasControllerEliminarEncuesta$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  doctorEncuestasControllerEliminarEncuesta(params: DoctorEncuestasControllerEliminarEncuesta$Params, context?: HttpContext): Observable<void> {
    return this.doctorEncuestasControllerEliminarEncuesta$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `doctorEncuestasControllerClonarEncuesta()` */
  static readonly DoctorEncuestasControllerClonarEncuestaPath = '/api/doctor-encuestas/clonar-encuesta/{uuidEncuesta}';

  /**
   * Clonar una encuesta.
   *
   * Clona una encuesta existente (incluyendo preguntas y respuestas) y la guarda como nueva.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `doctorEncuestasControllerClonarEncuesta()` instead.
   *
   * This method doesn't expect any request body.
   */
  doctorEncuestasControllerClonarEncuesta$Response(params: DoctorEncuestasControllerClonarEncuesta$Params, context?: HttpContext): Observable<StrictHttpResponse<EncuestaDto>> {
    return doctorEncuestasControllerClonarEncuesta(this.http, this.rootUrl, params, context);
  }

  /**
   * Clonar una encuesta.
   *
   * Clona una encuesta existente (incluyendo preguntas y respuestas) y la guarda como nueva.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `doctorEncuestasControllerClonarEncuesta$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  doctorEncuestasControllerClonarEncuesta(params: DoctorEncuestasControllerClonarEncuesta$Params, context?: HttpContext): Observable<EncuestaDto> {
    return this.doctorEncuestasControllerClonarEncuesta$Response(params, context).pipe(
      map((r: StrictHttpResponse<EncuestaDto>): EncuestaDto => r.body)
    );
  }

  /** Path part for operation `doctorEncuestasControllerObtenerUsuariosEncuesta()` */
  static readonly DoctorEncuestasControllerObtenerUsuariosEncuestaPath = '/api/doctor-encuestas/encuestas-usuarios/{uuidEncuesta}';

  /**
   * Obtener usuarios de una encuesta por UUID de encuesta.
   *
   * Obtiene los usuarios asociados a una encuesta específica utilizando su UUID.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `doctorEncuestasControllerObtenerUsuariosEncuesta()` instead.
   *
   * This method doesn't expect any request body.
   */
  doctorEncuestasControllerObtenerUsuariosEncuesta$Response(params: DoctorEncuestasControllerObtenerUsuariosEncuesta$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<RespuestaEncuestaPacienteModelDto>>> {
    return doctorEncuestasControllerObtenerUsuariosEncuesta(this.http, this.rootUrl, params, context);
  }

  /**
   * Obtener usuarios de una encuesta por UUID de encuesta.
   *
   * Obtiene los usuarios asociados a una encuesta específica utilizando su UUID.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `doctorEncuestasControllerObtenerUsuariosEncuesta$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  doctorEncuestasControllerObtenerUsuariosEncuesta(params: DoctorEncuestasControllerObtenerUsuariosEncuesta$Params, context?: HttpContext): Observable<Array<RespuestaEncuestaPacienteModelDto>> {
    return this.doctorEncuestasControllerObtenerUsuariosEncuesta$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<RespuestaEncuestaPacienteModelDto>>): Array<RespuestaEncuestaPacienteModelDto> => r.body)
    );
  }

  /** Path part for operation `doctorEncuestasControllerObtenerEncuestasDeUsuarios()` */
  static readonly DoctorEncuestasControllerObtenerEncuestasDeUsuariosPath = '/api/doctor-encuestas/obtener-encuestas-usuarios';

  /**
   * Obtiene pacientes que han respondido encuestas.
   *
   * Obtiene los pacientes que han respondido a una encuesta específica utilizando su UUID.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `doctorEncuestasControllerObtenerEncuestasDeUsuarios()` instead.
   *
   * This method doesn't expect any request body.
   */
  doctorEncuestasControllerObtenerEncuestasDeUsuarios$Response(params?: DoctorEncuestasControllerObtenerEncuestasDeUsuarios$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PacienteModelDto>>> {
    return doctorEncuestasControllerObtenerEncuestasDeUsuarios(this.http, this.rootUrl, params, context);
  }

  /**
   * Obtiene pacientes que han respondido encuestas.
   *
   * Obtiene los pacientes que han respondido a una encuesta específica utilizando su UUID.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `doctorEncuestasControllerObtenerEncuestasDeUsuarios$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  doctorEncuestasControllerObtenerEncuestasDeUsuarios(params?: DoctorEncuestasControllerObtenerEncuestasDeUsuarios$Params, context?: HttpContext): Observable<Array<PacienteModelDto>> {
    return this.doctorEncuestasControllerObtenerEncuestasDeUsuarios$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<PacienteModelDto>>): Array<PacienteModelDto> => r.body)
    );
  }

  /** Path part for operation `doctorEncuestasControllerObtenerRespuestasPaciente()` */
  static readonly DoctorEncuestasControllerObtenerRespuestasPacientePath = '/api/doctor-encuestas/obtener-respuestas-paciente/{uuidPaciente}';

  /**
   * Obtener encuestas respondidas de paciente por UUID de paciente.
   *
   * Obtiene las respuestas de todas las encuestas que ha respondido un paciente.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `doctorEncuestasControllerObtenerRespuestasPaciente()` instead.
   *
   * This method doesn't expect any request body.
   */
  doctorEncuestasControllerObtenerRespuestasPaciente$Response(params: DoctorEncuestasControllerObtenerRespuestasPaciente$Params, context?: HttpContext): Observable<StrictHttpResponse<EncuestaPacienteModelDto>> {
    return doctorEncuestasControllerObtenerRespuestasPaciente(this.http, this.rootUrl, params, context);
  }

  /**
   * Obtener encuestas respondidas de paciente por UUID de paciente.
   *
   * Obtiene las respuestas de todas las encuestas que ha respondido un paciente.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `doctorEncuestasControllerObtenerRespuestasPaciente$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  doctorEncuestasControllerObtenerRespuestasPaciente(params: DoctorEncuestasControllerObtenerRespuestasPaciente$Params, context?: HttpContext): Observable<EncuestaPacienteModelDto> {
    return this.doctorEncuestasControllerObtenerRespuestasPaciente$Response(params, context).pipe(
      map((r: StrictHttpResponse<EncuestaPacienteModelDto>): EncuestaPacienteModelDto => r.body)
    );
  }

  /** Path part for operation `doctorEncuestasControllerObtenerRespuestasEncuesta()` */
  static readonly DoctorEncuestasControllerObtenerRespuestasEncuestaPath = '/api/doctor-encuestas/obtener-respuestas-paciente/{uuidPaciente}/{uuidEncuesta}';

  /**
   * Obtener respuesta de paciente a una encuesta.
   *
   * Obtiene las respuestas de una encuesta que ha respondido un paciente.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `doctorEncuestasControllerObtenerRespuestasEncuesta()` instead.
   *
   * This method doesn't expect any request body.
   */
  doctorEncuestasControllerObtenerRespuestasEncuesta$Response(params: DoctorEncuestasControllerObtenerRespuestasEncuesta$Params, context?: HttpContext): Observable<StrictHttpResponse<PacienteEncuestaRespuestaModelDto>> {
    return doctorEncuestasControllerObtenerRespuestasEncuesta(this.http, this.rootUrl, params, context);
  }

  /**
   * Obtener respuesta de paciente a una encuesta.
   *
   * Obtiene las respuestas de una encuesta que ha respondido un paciente.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `doctorEncuestasControllerObtenerRespuestasEncuesta$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  doctorEncuestasControllerObtenerRespuestasEncuesta(params: DoctorEncuestasControllerObtenerRespuestasEncuesta$Params, context?: HttpContext): Observable<PacienteEncuestaRespuestaModelDto> {
    return this.doctorEncuestasControllerObtenerRespuestasEncuesta$Response(params, context).pipe(
      map((r: StrictHttpResponse<PacienteEncuestaRespuestaModelDto>): PacienteEncuestaRespuestaModelDto => r.body)
    );
  }

  /** Path part for operation `doctorEncuestasControllerObtenerDetallesEncuesta()` */
  static readonly DoctorEncuestasControllerObtenerDetallesEncuestaPath = '/api/doctor-encuestas/detalle-encuesta/{uuidEncuesta}';

  /**
   * Obtener todas las encuestas.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `doctorEncuestasControllerObtenerDetallesEncuesta()` instead.
   *
   * This method doesn't expect any request body.
   */
  doctorEncuestasControllerObtenerDetallesEncuesta$Response(params: DoctorEncuestasControllerObtenerDetallesEncuesta$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<EncuestaDto>>> {
    return doctorEncuestasControllerObtenerDetallesEncuesta(this.http, this.rootUrl, params, context);
  }

  /**
   * Obtener todas las encuestas.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `doctorEncuestasControllerObtenerDetallesEncuesta$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  doctorEncuestasControllerObtenerDetallesEncuesta(params: DoctorEncuestasControllerObtenerDetallesEncuesta$Params, context?: HttpContext): Observable<Array<EncuestaDto>> {
    return this.doctorEncuestasControllerObtenerDetallesEncuesta$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<EncuestaDto>>): Array<EncuestaDto> => r.body)
    );
  }

}
